import { Component } from '@angular/core';
import { CourseCall } from '../../../../models/CourseCall';
import { SortColumn } from '../../../../models/GenericCRUD/SortColumn';
import { ActiveFilter } from '../../../../models/GenericCRUD/ActiveFilter';
import { GenericCrudService } from '../../../../services/generic-crud.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { Breadcrumb } from '../../../../models/Breadcrumb';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';
@Component({
  selector: 'app-course-call-home',
  standalone: true,
  imports: [GenericCrudComponent],
  templateUrl: './course-call-home.component.html',
  styleUrl: './course-call-home.component.css'
})
export class CourseHomeComponent {

  typeToShow: string = 'T';
  coursesList: CourseCall[] = [];
  loadItemsSlug = '/course/index';
  sortColumns: SortColumn[] = [];
  activeFilters: ActiveFilter[] = [];

  constructor(private crudService: GenericCrudService, private spinner: NgxSpinnerService, private breadcrumbService: BreadcrumbService) {
  }


  tableColums: GenericTableColumn[] = [
    { name: 'Nombre', active: true, type: 'course-call-name', key: 'name', sort: true },
    { name: 'Fechas', active: true, type: 'date-range', key: ['start_date', 'end_date'], format: 'dd/MM/yyyy', sort: true },
    { name: 'Tope inscripción', active: true, type: 'date', key: 'registration_deadline', format: 'dd/MM/yyyy', sort: true },
    { name: 'Alumnos', active: true, type: 'percentage', key: ['n_students', 'student_percentage'], sort: false },
    { name: 'Profesores', active: true, type: 'text', key: 'n_teachers', sort: false },
    { name: 'Sucursal', active: false, type: 'text', key: 'office.name', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'course_id', type: 'select', label: 'Curso', validations: 'required', url: '/config/course/all', singleSelection: true },
    { name: 'start_date', type: 'date', label: 'Fecha de Inicio', validations: 'required' },
    { name: 'end_date', type: 'date', label: 'Fecha de Fin', validations: 'required' },
    { name: 'expiration_date', type: 'date', label: 'Fecha de Expiración', validations: 'required' },
    { name: 'registration_deadline', type: 'date', label: 'Tope de Inscripción', validations: 'required' },
    { name: 'capacity', type: 'number', label: 'Capacidad del Curso', validations: 'required' },
    { name: 'teachers', type: 'select', label: 'Profesores', validations: 'required', url: '/user/teachers', singleSelection: false },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'required', url: '/config/office/listAll', singleSelection: true },
    { name: 'classroom_id', type: 'select', label: 'Aula', singleSelection: true, fieldListener: 'office_id', subfieldListener: 'classrooms', url: '/config/office/listAll' },
    { name: 'user_ids', type: 'select', label: 'Alumnos', colspan: 1, singleSelection: false, validations: '', url: '/user/students' },
    { name: 'lessons', type: 'dateRepeater', label: 'Días', colspan: 2, fieldListener: 'teachers', showIf: (formValue: any) => {
      const course = formValue?.course_id;
      if (!course) return true;
      const type = typeof course === 'object' ? course.type : null;
      return type !== 'Practico';
    }},
  ];


  formFieldsEdit: GenericFormField[] = [
    { name: 'course_id', type: 'select', label: 'Curso', validations: 'required', url: '/config/course/all', singleSelection: true },
    { name: 'start_date', type: 'date', label: 'Fecha de Inicio', validations: 'required' },
    { name: 'end_date', type: 'date', label: 'Fecha de Fin', validations: 'required' },
    { name: 'expiration_date', type: 'date', label: 'Fecha de Expiración', validations: 'required' },
    { name: 'registration_deadline', type: 'date', label: 'Tope de Inscripción', validations: 'required' },
    { name: 'capacity', type: 'number', label: 'Capacidad del Curso', validations: 'required' },
    { name: 'teachers', type: 'select', label: 'Profesores', validations: 'required', url: '/user/teachers', singleSelection: false },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'required', url: '/config/office/listAll', singleSelection: true },
    { name: 'classroom_id', type: 'select', label: 'Aula', singleSelection: true, fieldListener: 'office_id', subfieldListener: 'classrooms', url: '/config/office/listAll' },
    { name: 'lessons', type: 'dateRepeater', label: 'Días', fieldListener: 'teachers', colspan: 2, showIf: (formValue: any) => {
      const course = formValue?.course_id;
      if (!course) return true;
      const type = typeof course === 'object' ? course.type : null;
      return type !== 'Practico';
    }},
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'curso',
    createButtonTitle: 'Nuevo Curso',
    cols: 2,
    createApiSlug: '/course/store',
    formTitle: 'Crear Curso',
    formButtonTitle: 'Crear Curso',
    finishLabel: 'Crear Convocatoria',
    width: '4xl',
    steps: [
      { label: 'Curso y fechas', fieldNames: ['course_id', 'start_date', 'end_date', 'registration_deadline', 'expiration_date', 'capacity'] },
      { label: 'Ubicacion y profesores', fieldNames: ['office_id', 'classroom_id', 'teachers'] },
      { label: 'Clases y alumnos', fieldNames: ['lessons', 'user_ids'] },
    ]
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'tipo de curso',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/course/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{course_name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        finishLabel: 'Guardar Cambios',
        width: '4xl',
        steps: [
          { label: 'Curso y fechas', fieldNames: ['course_id', 'start_date', 'end_date', 'registration_deadline', 'expiration_date', 'capacity'] },
          { label: 'Ubicacion y profesores', fieldNames: ['office_id', 'classroom_id', 'teachers'] },
          { label: 'Clases', fieldNames: ['lessons'] },
        ],
        
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar el curso ?',
      deleteRowOnResponse: true,
      actionSlug: '/course/delete/{{id}}',
    }
  ];

  table: GenericTable<Paginator<CourseCall>> = {
    columns: this.tableColums,
    items: [],
    type: 'course',
    loadItemsSlug: '/course/index?type=theorical',
    loadTheoricalCoursesSlug: '/course/index?type=theorical',
    loadPracticalCoursesSlug: '/course/index?type=practical',
    paginate: true,
    name: 'tipos-de-curso',
    actions: this.tableActions,
    details: true,
    exportable: true,
  };

  filters: Filter[] = [
          /*{type: 'search', key: 'name|description', operator: 'like', placeholder: 'Nombre o descripción'},
          {type: 'multiselect', key: 'type.name', operator: 'in', placeholder: 'Tipo', optionsList: [{id:'Practico',name:'Práctico'},{id:'Teorico/Practico',name:'Teórico/Práctico'},{id:'Teorico',name:'Teórico'}], relation_filter_column: 'type'},
          {type: 'multiselect', key: 'license.name', operator: 'in', placeholder: 'Permiso oficial', url: '/config/license/listAll', relation_filter_column: 'license_id'},
          {type: 'multiselect', key: 'virtual_classroom.name', operator: 'in', placeholder: 'Aula virtual', url: '/config/virtual-classroom/listAll', relation_filter_column: 'virtual_classroom_id'},
        */];

  genericCRUD: GenericCRUD<Paginator<CourseCall>> = {
    genericTable: this.table,
    genericForm: this.form,
    genericFilters: this.filters,
    useModalForm: false
  }

}
